import { render, staticRenderFns } from "./GoodsCard.vue?vue&type=template&id=31bc991f&scoped=true&"
import script from "./GoodsCard.vue?vue&type=script&lang=js&"
export * from "./GoodsCard.vue?vue&type=script&lang=js&"
import style0 from "./GoodsCard.vue?vue&type=style&index=0&id=31bc991f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bc991f",
  null
  
)

export default component.exports